import { Activity, AlertTriangle, CheckCircle2 } from 'lucide-react'

export function CountChip({
  label,
  value,
  tone,
}: {
  label: string
  value: number
  tone: 'ok' | 'bad' | 'info' | 'muted'
}) {
  const cls =
    tone === 'ok'
      ? 'bg-success/10 text-success border-success/30'
      : tone === 'bad'
        ? 'bg-destructive/10 text-destructive border-destructive/30'
        : tone === 'info'
          ? 'bg-info/10 text-info border-info/30'
          : 'bg-muted text-muted-foreground border-border'
  const Icon = tone === 'bad' ? AlertTriangle : tone === 'ok' ? CheckCircle2 : Activity
  return (
    <div className={`inline-flex items-center gap-2 rounded-md border px-3 py-1.5 ${cls}`}>
      <Icon className="h-3.5 w-3.5" />
      <span className="text-xs uppercase tracking-wide">{label}</span>
      <span className="text-sm font-semibold tabular-nums">{value}</span>
    </div>
  )
}
